import { lazy } from "react";

const PointHistoryPage = lazy(() => import("./main"));
export { PointHistoryPage };
